module.exports = __webpack_public_path__ + "static/img/18@2x.397d77ca.png";